/*
 * @Description: 获取uid
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-11 18:43:58
 * @LastEditors: zhouhong07
 * @LastEditTime: 2020-03-06 16:54:26
 */
import Cookie from './cookie' ;

const getUid = () => {

  let temp = Cookie.get('PPU') ? Cookie.get('PPU').split("&")[0] : "";
  let res = temp.indexOf("UID") ? temp.slice(5) : "" ;
  // console.log('uid',Cookie.get('PPU'),res);
  // res = "33259802462218" ;
  return res ;
}

const getCid = () => {
  let res = 1 ;
  if(Cookie.get('commontopbar_new_city_info')){
    let temp = decodeURI(Cookie.get('commontopbar_new_city_info')).split("|")[0];
    res = temp;
  }
  
  return res ;
} 

const getCity = () => {
  let res = '北京' ;
  if(Cookie.get('commontopbar_new_city_info')){
    let temp = decodeURI(Cookie.get('commontopbar_new_city_info')).split("|")[1];
    res = temp;
  }
  
  return res ;
}

//ip定位城市
const getCname = () => {
  let res = "bj" ;
  if(Cookie.get('commontopbar_ipcity')){
    let temp = decodeURI(Cookie.get('commontopbar_ipcity')).split("|")[0];
    res = temp;
  }
  return res ;
}

export {
  getUid ,
  getCid ,
  getCity ,
  getCname
}